import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from '@environment';
import { TicketBulkReplyAddModel } from '../../core/models/ticket-bulk-reply-add-model.model';
import { BulkOperationResult } from '../../core/models/bulk-operation-result.model';
import { TicketBulkTagsUpdate } from '../../core/models/ticket-bulk-tags-update.model';
import { TicketBulkAssignOperationModel } from '../../core/models/ticket-bulk-assign-operation-model.model';
import { TicketBulkCategoryUpdate } from '../../core/models/ticket-bulk-category-update.model';
import { TicketBulkStatusUpdate } from '../../core/models/ticket-bulk-status-update.model';

@Injectable({
    providedIn: 'root',
})
export class BulkOperationsService {
    constructor(private httpClient: HttpClient) {}

    addReply(data: TicketBulkReplyAddModel): Observable<BulkOperationResult> {
        return this.httpClient.post<BulkOperationResult>(
            environment.apiInboxUrl + 'tickets/bulkOperations/replies',
            data,
        );
    }

    addTags(data: TicketBulkTagsUpdate): Observable<BulkOperationResult> {
        return this.httpClient.post<BulkOperationResult>(environment.apiInboxUrl + 'tickets/bulkOperations/tags', data);
    }

    assign(data: TicketBulkAssignOperationModel): Observable<BulkOperationResult> {
        return this.httpClient.patch<BulkOperationResult>(
            environment.apiInboxUrl + 'tickets/bulkOperations/assign',
            data,
        );
    }

    linkTickets(data: number[]): Observable<BulkOperationResult> {
        return this.httpClient.patch<BulkOperationResult>(
            environment.apiInboxUrl + 'tickets/bulkOperations/link',
            data,
        );
    }

    updateCategory(data: TicketBulkCategoryUpdate): Observable<BulkOperationResult> {
        return this.httpClient.patch<BulkOperationResult>(
            environment.apiInboxUrl + 'tickets/bulkOperations/category',
            data,
        );
    }

    updateStatus(data: TicketBulkStatusUpdate): Observable<BulkOperationResult> {
        return this.httpClient.patch<BulkOperationResult>(
            environment.apiInboxUrl + 'tickets/bulkOperations/status',
            data,
        );
    }
}
